export const handleAPIError = (apiResponse, rejectWithValue) => {
  switch (apiResponse.error) {
    case true: {
      return rejectWithValue(apiResponse.response?.errors ? apiResponse.response.errors : apiResponse.error);
    }
    default:
      return apiResponse.response.data;
  }
};
